import { FC, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import './Onboarding.scss'
import React from 'react'
import { getUserData, getUserOnboardingData, userOnboarding, userOnboardingAnswer } from '../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import MultipleSelect from './MultipleSelect'
import CompoundMultipleSelect from './CompoundMultipleSelect'
import CompoundSingleSelect from './CompoundSingleSelect'
import Finish from './Finish'
import SingleSelect from './SingleSelect'
import Video from './Video'
import VideoCollapse from './VideoCollapse'

type OnboardingQuestion = {
  questionId: string;
  title: string;
  subTitle: string;
  options: string[];
  type: string;
  subQuestions: OnboardingQuestion[]
  other: {
    title: string;
    options: string[];
  }
}

type AnswerType = string | null | Record<string, string> | string[] | [] | Record<string, string[]> | boolean;

const MULTIPLE_CHOICE = 'multiple-choice';
const SINGLE_CHOICE = 'single-choice';
const COMPOUND_MULTIPLE_SELECT = 'compound-multiple-select';
const COMPOUND_SINGLE_SELECT = 'compound-single-select';
const VIDEO = 'video';
const VIDEO_COLLAPSE = 'video-collapse';

const OnboardingPage: FC = () => {
  const dispatch = useDispatch();

  const onboarding = useSelector(getUserOnboardingData);
  const user = useSelector(getUserData);

  const [isDisable, setIsDisable] = useState(true);
  const [answers, setAnswers] = useState<AnswerType>(null);

  const handleButtonDisable = (value = false) => {
    setIsDisable(value)
  };

  const handleAnswer = (answers: AnswerType) => {
    setAnswers(answers)
  };

  const handleSubmit = (answers: AnswerType) => {
    const nextStep = onboarding.step === onboarding.total ? onboarding.step : onboarding.step + 1;
    const payload = {
      "answers": answers,
      "nextStep": nextStep,
      "questionId": onboarding?.questions[0]?.questionId
    }

    dispatch(userOnboardingAnswer(payload))
  };

  const handleSkip = (answers: AnswerType) => {
    const nextStep = onboarding.step === onboarding.total ? onboarding.step : onboarding.step + 1;
    const payload = {
      "answers": answers,
      "nextStep": nextStep,
      "questionId": onboarding?.questions[0]?.questionId
    }

    dispatch(userOnboardingAnswer(payload))
  };

  const handleBack = () => {
    dispatch(userOnboarding(onboarding.step === 1 ? 1 : onboarding.step - 1))
  }

  if (onboarding.isFinished) {
    return <></>
  }

  if (onboarding.isComplete) {
    return <Finish />
  }

  const buttonTextSubmit = onboarding.step === onboarding.total ? 'Launch Cellcast' : 'Submit';

  return (
    <div className='onboarding flex items-center justify-center min-h-screen'>
      {!onboarding.isComplete && (onboarding.step === 1) ? (
        <div className='d-flex justify-content-center'>
          <div className='w-75'>
            <h1 className='display-6 lh-base mb-2 fw-boldest onboarding-first-title text-center'>
              Welcome aboard,{' '}
              <span className='display-6 text-primary lh-base mb-2 fw-boldest'>
                {user?.user?.firstName}
              </span>
            </h1>
            <p className='fw-normal onboarding-description'>
              At Cellcast, we believe your experience should be as unique as you are. Let’s set things up together, so you get exactly what you need, how you need it. First thing first. Tell us a bit more about you.
            </p>

          <div className='divider' />
          </div>
        </div>
      ) : null}

      {!onboarding.isComplete && onboarding.step > 1 ? (
        <p className='fw-normal onboarding-description text-primary'>
          Step {onboarding.step - 1 } of {onboarding.total - 1} {onboarding.currentStep === 2 ? ': This will only take 2 minute' : null}
        </p>
      ) : null}

      {onboarding?.questions && onboarding.questions.map((item: OnboardingQuestion, index: number) => {
        if (item.type === VIDEO) {
          return <Video setIsDisable={handleButtonDisable} key={index} data={item} />
        }

        if (item.type === VIDEO_COLLAPSE) {
          return <VideoCollapse setIsDisable={handleButtonDisable} key={index} data={item} />
        }

        if (item.type === SINGLE_CHOICE) {
          return <SingleSelect onSubmit={handleAnswer} setIsDisable={handleButtonDisable} key={index} data={item} />
        }

        if (item.type === MULTIPLE_CHOICE) {
          return <MultipleSelect onSubmit={handleAnswer} setIsDisable={handleButtonDisable} key={index} data={item} />
        }

        if (item.type === COMPOUND_MULTIPLE_SELECT) {
          return <CompoundMultipleSelect onSubmit={handleAnswer} setIsDisable={handleButtonDisable} key={index} data={item} />
        }

        if (item.type === COMPOUND_SINGLE_SELECT) {
          return <CompoundSingleSelect onSubmit={handleAnswer} setIsDisable={handleButtonDisable} key={index} data={item} />
        }

        return <></>
      })}

      {!onboarding.isComplete ? (
        <div className={`d-flex ${onboarding.step === 1 ? 'justify-content-center' : 'justify-content-between'} align-items-center mt-20`}>
          {/* Left side: Back button */}
          {onboarding.step > 1 ? (
            <button
              className="btn btn-secondary"
              type="button"
              onClick={handleBack}
              disabled={onboarding.step === 1}
            >
              Back
            </button>
          ) : <div></div>}

          {/* Right side: Skip and Next/Submit buttons */}
          <div className="d-flex gap-2">
            {(onboarding.step !== 1) && onboarding.step < onboarding.total ? (
            <button
              className="btn btn-light"
              type="button"
              onClick={() => handleSkip(answers)}
            >
              Skip
            </button>
            ) : null}

            <button
              className="btn btn-primary"
              type="button"
              data-kt-element="next"
              disabled={isDisable}
              onClick={() => handleSubmit(answers)}
            >
              {onboarding.currentStep !== onboarding.total ? 'Next' : buttonTextSubmit}
              {/* {onboarding.isLoading && (
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              )} */}
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default React.memo(OnboardingPage)
